<template>
  <div class="modal_wrapper">
    <div class="modal" :class="type">
      <div class="header">
        {{title}}
        <span class="close_button" @click="cancel"></span>
      </div>
      <div class="body">
        <div class="content mb-2" v-html="content"></div>
        <div class="buttons mb-2">
          <span class="button button_small button_rounded bordered" :class="{tree_green: type === 'success'}" @click="ok">{{ok_text}}</span>
          <span class="button button_small button_rounded bordered" :class="{tree_green: type === 'success'}" @click="cancel">{{cancel_text}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ok_text: {type: String, default: 'はい'},
    cancel_text: {type: String, default: 'キャンセル'},
    type: {type: String, default: 'success'},
    title: {type: String, required: false, default: ''},
    content: {type: String, required: false, default: ''}
  },
  methods: {
    ok () {
      this.$emit('ok')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal.vue